import styled from 'styled-components';

import { ColorShades } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Indicator = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background: ${ct({ Dark: ColorShades.Red50, Light: ColorShades.Red50 })};
`;

export const Wrapper = styled.div`
  position: relative;
`;
